import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    trackingSchemaId: '',
    assetId: '',
};
const { actions, reducer } = createSlice({
    name: 'tableFollowUpPrefs',
    initialState,
    reducers: {
        setTrackingSchemaID: (state, { payload }) => {
            state.trackingSchemaId = payload;
        },
        setAssetId: (state, { payload }) => {
            state.assetId = payload;
        },
    },
});
export const { setTrackingSchemaID, setAssetId } = actions;
export default reducer;
